import { z } from 'zod';
import {
    CloverNormalizedGatewayTransactionDetailsSchema,
    CloverTransactionDetailsPaymentBodySchema,
    CloverTransactionDetailsRequestHeadersSchema,
} from './clover-transaction-details.schemas';
import {
    type CloverNormalizedTransactionStatusLookupResult,
    type CloverPaymentExternalResponseBody,
    CloverTransactionStatusOutcome,
    type CloverTransactionStatusRequestDetails,
    type CloverTransactionStatusResponseDetails,
} from '../../../types/ipg/clover/clover-transaction-status.types';

export const CloverTransactionStatusRequestDetailsSchema: z.ZodType<CloverTransactionStatusRequestDetails> =
    z.object({
        method: z.literal('GET'),
        path: z.literal('/v1/payments/external/{externalPaymentId}'),
        externalPaymentId: z.string().min(1),
        headers: CloverTransactionDetailsRequestHeadersSchema,
    });

export const CloverPaymentExternalResponseBodySchema: z.ZodType<CloverPaymentExternalResponseBody> =
    CloverTransactionDetailsPaymentBodySchema;

export const CloverNormalizedTransactionStatusLookupResultSchema: z.ZodType<CloverNormalizedTransactionStatusLookupResult> =
    z.object({
        gateway_transaction_details: CloverNormalizedGatewayTransactionDetailsSchema,
    });

export const CloverTransactionStatusResponseDetailsSchema: z.ZodType<CloverTransactionStatusResponseDetails> =
    z.discriminatedUnion('outcome', [
        z.object({
            outcome: z.literal(CloverTransactionStatusOutcome.FOUND),
            httpStatus: z.literal(200),
            rawDetails: CloverPaymentExternalResponseBodySchema,
            normalizedDetails: CloverNormalizedGatewayTransactionDetailsSchema,
        }),
        z.object({
            outcome: z.literal(CloverTransactionStatusOutcome.MISSING),
            httpStatus: z.number().int().positive(),
            rawDetails: z.unknown(),
            message: z.string().min(1),
        }),
        z.object({
            outcome: z.literal(CloverTransactionStatusOutcome.MALFORMED_RESPONSE),
            httpStatus: z.number().int().positive(),
            rawDetails: z.unknown(),
            message: z.string().min(1),
        }),
    ]);
